export function normalizeToArray<T>(array: T | T[]): T[] {
  return Array.isArray(array) ? array : [array];
}

export function swapArrayLocs<T>(data: T[], from: number, to: number): T[] {
  const newData = [...data];
  if (from !== to) {
    newData.splice(from, 1);
    newData.splice(to, 0, data[from]);
  }
  return newData;
}

export const keyExtractor = <T extends { id: string; queueId?: string }>(
  item: T,
): string => item.queueId || item.id;
